import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './SVGIcon.scss';
import {SvgComponent} from '../../../reactDomTypes';

export interface SVGIconProps {
  Svg: SvgComponent;
  className?: string;
  accName?: string;
  accHidden?: boolean;
  dataHook?: string;
}

const SVGIcon: React.FC<SVGIconProps> = ({
  Svg,
  className,
  accName,
  accHidden = false,
  dataHook = 'svg-inline-icon',
}) => {
  return (
    <div
      className={classNames([styles.svgIconWrapper, className])}
      aria-label={accName}
      aria-hidden={accHidden}
      data-hook={dataHook}
    >
      <Svg />
    </div>
  );
};

SVGIcon.propTypes = {
  Svg: PropTypes.any.isRequired,
  className: PropTypes.string,
  accName: PropTypes.string,
  accHidden: PropTypes.bool,
  dataHook: PropTypes.string,
};

export {SVGIcon};
